import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption1, Tooltip } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getCanLoggedUserChangeBillableStatus } from "~/store/selectors/selector.tracking";
import { hoursFormatted } from "~/utils/utils";
import { HeaderTooltip } from "./HeaderTooltip";

export const GroupHeaderTotal = ({ total, projectId, ...rest }) => {
  const { t } = useTranslation();

  const canSeeBillable = useSelector((state) => getCanLoggedUserChangeBillableStatus(state, { projectId }));

  return (
    <Tooltip
      title={<HeaderTooltip {...rest} />}
      disable={!canSeeBillable}
    >
      <Caption1
        color="secondary"
        weight="medium"
        className={classNames({ "tw-cursor-help": canSeeBillable })}
        tabularNums
      >
        {t("Total")}: {hoursFormatted({ hours: 0, minutes: total }, false, true)}h
      </Caption1>
    </Tooltip>
  );
};

GroupHeaderTotal.propTypes = {
  total: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
};
